"use strict";
var UsingObservable_1 = require('./UsingObservable');
exports.using = UsingObservable_1.UsingObservable.create;
//# sourceMappingURL=using.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/rxjs/observable/using.js
// module id = ../../../../rxjs/observable/using.js
// module chunks = 11